// extracted by mini-css-extract-plugin
module.exports = {"hero":"HeroImage_hero__3i0l5","fadein":"HeroImage_fadein__31xHC"};